var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjectives(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.878V3C4 2.40326 4.23705 1.83097 4.65901 1.40901C5.08097 0.987053 5.65326 0.75 6.25 0.75H13.75C14.3467 0.75 14.919 0.987053 15.341 1.40901C15.7629 1.83097 16 2.40326 16 3V3.878M4 3.878C4.235 3.795 4.487 3.75 4.75 3.75H15.25C15.513 3.75 15.765 3.795 16 3.878M4 3.878C3.56121 4.03313 3.18133 4.32052 2.91269 4.70056C2.64404 5.0806 2.49986 5.5346 2.5 6V6.878M16 3.878C16.4388 4.03313 16.8187 4.32052 17.0873 4.70056C17.356 5.0806 17.5001 5.5346 17.5 6V6.878M2.5 6.878C2.735 6.795 2.987 6.75 3.25 6.75H16.75C17.0055 6.7497 17.2591 6.79299 17.5 6.878M2.5 6.878C1.626 7.187 1 8.02 1 9V15C1 15.5967 1.23705 16.169 1.65901 16.591C2.08097 17.0129 2.65326 17.25 3.25 17.25H16.75C17.3467 17.25 17.919 17.0129 18.341 16.591C18.7629 16.169 19 15.5967 19 15V9C19.0001 8.5346 18.856 8.0806 18.5873 7.70056C18.3187 7.32052 17.9388 7.03313 17.5 6.878",
    stroke: "#250056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectives);
export default __webpack_public_path__ + "static/media/objectives.bef5a43f932dcf2676979d8357f71a7b.svg";
export { ForwardRef as ReactComponent };